import React from "react";
import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";

interface MemoryThankYouCardProps {
  deceasedName: string;
  backgroundImage: string; // path to background pattern
  logoImage: string; // path to muzukuru logo
}

export const MemoryThankYouCard: React.FC<MemoryThankYouCardProps> = ({
  deceasedName,
  backgroundImage,
  logoImage,
}) => {
  return (
    <Box
      sx={{
        width: 500,
        height: "auto",
        bgcolor: "#fff",
        borderRadius: 2,
        overflow: "hidden",
        position: "relative",
        boxShadow: 0,
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        p: 4,
        mt: 2,
      }}
    >
      {/* Logo */}
      <Box sx={{ mb: 2 }}>
        <img src={logoImage} alt="Muzukuru Logo" width={150} />
      </Box>

      {/* Title */}
      <Typography
        variant="h3"
        sx={{
          color: "#614438",
          fontWeight: 600,
          mb: 1,
        }}
      >
        Thank You for Sharing a Memory
      </Typography>

      {/* Subtitle */}
      <Typography
        variant="subtitle2"
        sx={{ color: "#614438", mb: 3, fontSize: "18px" }}
      >
        In loving memory of {deceasedName}
      </Typography>

      {/* Message */}
      <Typography
        sx={{
          color: "#000000",
          mb: 2,
          lineHeight: 1.6,
          fontFamily: "Josefin Sans,",
        }}
      >
        We deeply appreciate the time you took to write and share your thoughts
        during this difficult moment.
      </Typography>

      <Typography sx={{ color: "#000000", lineHeight: 1.6, mb: 3 }}>
        Your message has now been added to {deceasedName.split(" ")[0]}&apos;s
        Memory Book, where it will be treasured as part of their lasting legacy.
      </Typography>

      {/* Signature */}
      <Box sx={{ mt: 4 }}>
        <Typography
          sx={{ fontWeight: 500, color: "#614438", mb: 1, fontSize: 14 }}
        >
          From and on Behalf of the Muzukuru Team,
        </Typography>
        <Typography
          sx={{
            fontFamily: "cursive",
            color: "#614438",
            fontSize: 20,
            mb: 1,
          }}
        >
          Tawanda
        </Typography>

        <Typography sx={{ color: "#555", fontSize: 13 }}>
          Phone: +263 776 402 402 | tawanda@muzukuru.co.zw | www.muzukuru.co.zw
          <br />
          46B Mount Pleasant Drive, Mount Pleasant, Harare, Zimbabwe
        </Typography>
      </Box>
    </Box>
  );
};

MemoryThankYouCard.propTypes = {
  deceasedName: PropTypes.string.isRequired,
  backgroundImage: PropTypes.string.isRequired,
  logoImage: PropTypes.string.isRequired,
};
